/* eslint-disable import/extensions */
/* eslint-disable @typescript-eslint/no-var-requires */
import { Button, Modal } from 'antd';
import React, { useState } from 'react';
import ImgPoint from '../../../../../assets/animation_point.gif';
import './component002.less';

interface IComponent002Item {
  text: string;
  viewMore?: boolean;
  tip?: string;
}
interface IComponent002Props {
  text: string;
  img?: string;
  icon1?: string;
  icon2?: string;
  title1?: string;
  title2?: string;
  canDoItems: IComponent002Item[];
  cannotDoItems: string[];
  className?: string;
  pic: string;
  inTitle: string;
}

const Component002: React.FunctionComponent<IComponent002Props> = ({
  text,
  img,
  icon1,
  icon2,
  title1,
  title2,
  canDoItems,
  cannotDoItems,
  className,
  pic,
  inTitle,
}) => {
  const [isModalOpen, setModalOpen] = useState(false);
  const [show, setShow] = useState(true);
  return (
    <>
      <div className={`component002 ${className}`}>
        <div
          className={`component003 position-right ${!text ? 'no-text' : ''}`}
        >
          {text && (
            <>
              <div className="component003-tip">
                <span
                  className="tip-text"
                  dangerouslySetInnerHTML={{ __html: text }}
                />
                <div className="tip-arrow">
                  <div className="line1" />
                  <div className="line2" />
                </div>
                <img
                  src={require(`../../../../../assets/${img}`).default}
                  alt=""
                />
              </div>
            </>
          )}
        </div>
        <div className="cando-section">
          <div className="can-do">
            <div className="cando-img">
              <img
                src={require(`../../../../../assets/${icon1}`).default}
                alt=""
              />
            </div>
            <div className="cando-title" style={{ backgroundColor: '#0CA39A' }}>
              {title1}
            </div>
            <div className="cando-body">
              <div className="cando-content">
                <ul>
                  {canDoItems.map((itm: IComponent002Item, idx: number) => (
                    <li key={idx}>
                      <div className="cando-content-body">
                        {itm.text}
                        {itm.viewMore ? (
                          <div className="view-more">
                            <Button
                              className="view-more-btn"
                              onClick={() => {
                                setModalOpen(true);
                                setShow(false);
                              }}
                              type="link"
                            >
                              {itm.tip}
                              <img
                                className="click-point1"
                                hidden={!show}
                                src={ImgPoint}
                                alt=""
                              />
                            </Button>
                          </div>
                        ) : null}
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
          <div className="can-not-do">
            <div className="cando-img">
              <img
                src={require(`../../../../../assets/${icon2}`).default}
                alt=""
              />
            </div>
            <div className="cando-title" style={{ backgroundColor: '#E7444E' }}>
              {title2}
            </div>
            <div className="cando-body">
              <div className="cando-content">
                <ul>
                  {cannotDoItems.map((itm: string) => (
                    <li key={itm}>{itm}</li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal
        width="60%"
        className="component002-customer-modal"
        title={inTitle}
        footer={null}
        visible={isModalOpen}
        onCancel={() => setModalOpen(false)}
      >
        <img src={require(`../../../../../assets/${pic}`).default} alt="" />
      </Modal>
    </>
  );
};
export default Component002;
